import Select from "newComponents/Shared/Forms/Select/Select";
import React, { FC } from "react";

interface IProps {
  value: SelectOption;
  label: string;
  onChange: (id: string) => void;
  options: SelectOption[];
  customClass?: string;
}

const CoursesDropdown: FC<IProps> = ({ value, label, onChange, options, customClass }) => {
  return (
    <div className={`course-selection ${customClass || ""}`}>
      <p className="course-header">{label}</p>
      {options && (
        <Select
          selected={value?.label}
          options={options}
          onChange={(id) => onChange(id)}
          placeholder={value?.label}
          containerStyles={{ display: "flex" }}
        />
      )}
    </div>
  );
};

export default CoursesDropdown;
